import React from 'react'
import ProvideNormForWeekday from 'pages/app/inventory/norms/ProvideNormForWeekday'
import ForEachWeekday from 'support/helpers/ForEachWeekday'
import * as UI from 'ui'
import * as Displays from 'support/displays'
import { useValue } from '@morningtrain/react-resources'
import ResetNormOffsetAction from 'widgets/smartviews/inventory/ResetNormOffsetAction'

export default function InventoryItemNormSummary () {
  const item = useValue('item')

  return (
    <div className='mt-5'>
      <a href={`#item-row-${item.id}`}>
        <UI.Text weight='medium'>
          {item.name}
        </UI.Text>
      </a>
      <div className='space-y-1 mt-1'>
        <ForEachWeekday>
          {weekday => (
            <ProvideNormForWeekday weekday={weekday}>
              <UI.SpaceBetween>
                <UI.Text uppercase size='xs'>
                  {weekday.name} (<Displays.Change name='norm_offset' />)
                </UI.Text>
                <ResetNormOffsetAction weekday={weekday.index} itemId={item.id} />
              </UI.SpaceBetween>
            </ProvideNormForWeekday>
          )}
        </ForEachWeekday>
      </div>
    </div>
  )
}
